export default __webpack_public_path__ + "static/media/steak-peeksa.c8aff5c2.jpg";